export default __webpack_public_path__ + "static/photo9usluge-4c7cb745400088f353f71c5d673d55e8.png";